import type { TFunction } from 'i18next'

type Acknowledgement = { at: unknown, name: string, email?: string | null }

/** Les accusés de lecture d'un document en CSV (#326) : la preuve de remise, pour l'auditeur. */
export function acknowledgementsCsv(document: string, acks: readonly Acknowledgement[], t: TFunction, formatDate: (value: unknown) => string) {
  return {
    headers: [t('documents.column.title'), t('documents.acks.learner'), t('common.email'), t('documents.acks.at')],
    rows: acks.map(a => [document, a.name, a.email ?? '', formatDate(a.at)]),
  }
}
